import Vue from 'vue'
import store from '@/store'
import router from '@/router'
import http from '@/utils/http-common'
import Swal from 'sweetalert2'
import { DEFAULT_SORT_JSON } from './constants/userInfoSortJsonDefault'
import { AUTH_REFRESH_MODE } from './auth-refresh-mode'
import { refreshAccessTokenAsMethodRecall } from '@/utils/auth-service'
import { applyConsolePolicy, resetConsoleDebugSetting } from '@/utils/console-policy'

function methodRecall() { // main.js, mutations.js, actions.js, index.js(router) 공유
  return refreshAccessTokenAsMethodRecall();
}

export default {
  swalToast(state, payload) {
    console.log('swalToast', state, payload)
    Swal.mixin({
      toast: true,
      showClass: { popup: 'animate__animated animate__fadeInDown' },
      hideClass: { popup: 'animate__animated animate__fadeOutUp' },
      position: 'top',
      showConfirmButton: false,
      showCloseButton: true,
      timer: store.getters.toastTimer,
      timerProgressBar: false,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
      }
    }).fire({
      icon: payload.type === 'success' ? payload.type : null,
      // iconColor: payload.type === 'warning' ? '#ffc107' : 
      //           payload.type === 'success' ? '#7cfc00' : 
      //           payload.type === 'error' ? '#F44336' : 
      //           '#0D0E17',
      title: `<div style='font-size: 14px; color: #0D0E17; text-align: center'>${payload.title}<div>`,
      width: store.getters.toastWidth,
      background: store.getters.toastBgColor
    })
  },

  setIsMethodRecalling(state, payload) {
    state.isMethodRecalling = payload;
  },

  setOverlay(state, payload) {
    console.log('setOverlay', payload)
    state.overlay = payload;
  },
  setOverlayText(state, payload) {
    state.overlayText = payload;
  },

  setLlmRouteContext(state, payload) {
    state.llmRouteContext = payload;
  },
  clearLlmRouteContext(state) {
    state.llmRouteContext = null;
  },

  setDarkOverlay(state, payload) {
    state.darkOverlay = payload;
  },

  setDataUploadOverlay(state, payload) {
    state.dataUploadOverlay = payload;
  },
  setCurrentUploadDataCnt(state, payload) {
    state.currentUploadDataCnt = payload;
  },
  setTotalUploadDataCnt(state, payload) {
    state.totalUploadDataCnt = payload;
  },

  setRefreshToken(state, payload) {
    state.refresh_token = payload;
  },
  setAccessToken(state, payload) {
    state.access_token = payload;
  },
  setIdToken(state, payload) {
    state.id_token = payload;
  },
  setAuthRefreshMode(state, payload) {
    state.auth_refresh_mode = payload === 'cookie' ? 'cookie' : 'legacy';
    if (state.auth_refresh_mode === 'cookie') {
      state.refresh_token = "";
      state.access_token = "";
      state.id_token = "";
    }
  },

  logout(state) {
    console.log('logout')
    state.refresh_token = "";
    state.access_token = "";
    state.id_token = "";
    state.auth_refresh_mode = AUTH_REFRESH_MODE;
    state.is_token_updated = false;
    state.user_info = {};

    state.step_level = 1;
    state.project_list = [];
    state.project_icon_list = [];
    state.project_icon_image_urls = [];
    state.current_project = {};
    state.current_project_title = "";
    state.current_project_pk = null;
    state.current_project_sort = {};
    state.entity_label_list = [];

    state.dataList = [];
    state.multiTableDataList = [];
    state.file_list = [];
    state.db_list = [];
    state.statistics_list = [];
    state.ocr_list = [];

    state.rpa_list = [];
    state.rpa_result_list = [];
    state.current_rpa = {};
    state.rpa_view = 1;

    state.terminologyList = [];
    state.current_terminology_id = null;
    state.filter_word_list = [];
    state.append_file_list = [];

    state.disableDownload = false;

    state.asyncTaskStatusList = [];
    state.showAsyncTaskStatusListPanel = false;
    state.getDataListInterval = false;
    state.currentAsyncTask = null;
    state.currentAsyncTaskLogList = [];

    state.mouListDataToEdit = null;

    state.lastInnerDb = null;

    state.originDataList = [];

    state.tutorialStep = 0;
    state.rpaTutorialStep = 0;

    localStorage.removeItem("auth");
    localStorage.removeItem("recolumn");
    resetConsoleDebugSetting();
    applyConsolePolicy(state.user_info.organization_permission);
  },
  leaveProject(state) {
    state.step_level = 1;
    state.project_list = [];
    state.current_project = {};
    state.current_project_title = "";
    state.current_project_pk = null;
    state.current_project_sort = {};
    state.entity_label_list = [];

    state.dataList = [];
    state.multiTableDataList = [];
    state.file_list = [];
    state.db_list = [];
    state.statistics_list = [];
    state.ocr_list = [];

    state.rpa_list = [];
    state.rpa_result_list = [];
    state.current_rpa = {};
    state.rpa_view = 1;

    state.terminologyList = [];
    state.current_terminology_id = null;
    state.filter_word_list = [];
    state.append_file_list = [];

    state.disableDownload = false;

    state.asyncTaskStatusList = [];
    state.showAsyncTaskStatusListPanel = false;
    state.getDataListInterval = false;
    // state.currentAsyncTask = null;
    state.currentAsyncTaskLogList = [];

    state.mouListDataToEdit = null;

    state.lastInnerDb = null;

    state.originDataList = [];
    state.llmRouteContext = null;
  },

  // user_info 저장
  SET_USER_INFO(state, payload) {
    console.log('SET_USER_INFO', state, payload)
    const incomingSort = payload?.sort_json || {}
    const mergedSort = { ...DEFAULT_SORT_JSON, ...incomingSort }
    // user_info 자체를 새 객체로 치환 (추적/반응성 깔끔)
    state.user_info = {
      ...payload,
      sort_json: mergedSort,
    }
    applyConsolePolicy(state.user_info.organization_permission)
  },
  // user_info > sort_json > 특정 key 하나만 업데이트 (컴포넌트에서 쓰기 좋음)
  SET_USER_SORT_VALUE(state, { key, value }) {
    console.log('SET_USER_SORT_VALUE', state, key, value)
    if (!state.user_info) return
    // sort_json 없으면 생성 (Vue2 반응성 보장)
    if (!state.user_info.sort_json) {
      Vue.set(state.user_info, 'sort_json', { ...DEFAULT_SORT_JSON })
    }
    Vue.set(state.user_info.sort_json, key, value)
  },

  setUserInfo(state, payload) {
    console.log('setUserInfo', state, payload)
    let sortInfo = { ...DEFAULT_SORT_JSON }
    if (payload.sort_json === null || payload.sort_json === undefined) {
      payload.sort_json = sortInfo
    } else {
      payload.sort_json = Object.assign(sortInfo, payload.sort_json)
    }
    state.user_info = payload;
    applyConsolePolicy(state.user_info.organization_permission)
    if (!store.state.access_token) {
      console.log('store.state.access_token 없음')
      this.$store.commit('logout')
      this.$router.push('/').catch(() => {})
      return false
    }
    let body = {
      sort_json: payload.sort_json
    }
    console.log('body', body)
    http
    .put(`account/user/${store.state.user_info.pk || store.state.user_info.id}/`, body, { headers: { Authorization: 'Bearer ' + store.state.access_token }})
    .then(res => {
      console.log('setUserInfo res', res)
    })
    .catch(err => {
      console.log(err)
      console.log(err.response)
      if (err.response && err.response.status === 401) { // access token 만료
        methodRecall()
        .then(msg => {
          console.log(msg)
          // method 재호출
          http
          .put(`account/user/${store.state.user_info.pk}/`, body, { headers: { Authorization: 'Bearer ' + store.state.access_token }})
          .then(res => {
            console.log('setUserInfo res(methodRecall)', res)
          })
        })
        .catch(err_msg => {
          console.log(err_msg)
          if (err_msg === 0) {
            console.log('BE에 access token 저장 실패')
          } else { // err_msg === 1
            console.log('refresh token 만료(access token 갱신 실패)')
            Swal.mixin({
              toast: true,
              showClass: {
                popup: 'animate__animated animate__fadeInDown'
              },
              hideClass: {
                popup: 'animate__animated animate__fadeOutUp'
              },
              position: 'top',
              showConfirmButton: false,
              showCloseButton: true,
              timer: store.getters.toastTimer,
              timerProgressBar: false,
              didOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer)
                toast.addEventListener('mouseleave', Swal.resumeTimer)
              }
            }).fire({
              icon: "warning",
              iconColor: "#ffc107",
              title: "<div style='font-size: 16px; color: #0D0E17'>다시 로그인해 주세요.<div>",
              width: store.getters.toastWidth,
              background: store.getters.toastBgColor
            })
            store.commit('logout')
            router.push('/')
          }
        })
      }
    })
  },
  setUserInfoSort(state, payload) {
    console.log('setUserInfoSort', state, payload)
    let body = {
      sort_json: payload
    }
    console.log('body', body)
    if (!store.state.access_token) {
      console.log('store.state.access_token 없음')
      this.$store.commit('logout')
      this.$router.push('/').catch(() => {})
      return false
    }
    http
    .put(`account/user/${store.state.user_info.pk}/`, body, { headers: { Authorization: 'Bearer ' + store.state.access_token }})
    .then(res => {
      console.log('setUserInfoSort res', res)
    })
    .catch(err => {
      console.log(err)
      console.log(err.response)
      if (err.response && err.response.status === 401) { // access token 만료
        methodRecall()
        .then(msg => {
          console.log(msg)
          // method 재호출
          http
          .put(`account/user/${store.state.user_info.pk}/`, body, { headers: { Authorization: 'Bearer ' + store.state.access_token }})
          .then(res => {
            console.log(res)
          })
        })
        .catch(err_msg => {
          console.log(err_msg)
          if (err_msg === 0) {
            console.log('BE에 access token 저장 실패')
          } else { // err_msg === 1
            console.log('refresh token 만료(access token 갱신 실패)')
            Swal.mixin({
              toast: true,
              showClass: {
                popup: 'animate__animated animate__fadeInDown'
              },
              hideClass: {
                popup: 'animate__animated animate__fadeOutUp'
              },
              position: 'top',
              showConfirmButton: false,
              showCloseButton: true,
              timer: store.getters.toastTimer,
              timerProgressBar: false,
              didOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer)
                toast.addEventListener('mouseleave', Swal.resumeTimer)
              }
            }).fire({
              icon: "warning",
              iconColor: "#ffc107",
              title: "<div style='font-size: 16px; color: #0D0E17'>다시 로그인해 주세요.<div>",
              width: store.getters.toastWidth,
              background: store.getters.toastBgColor
            })
            store.commit('logout')
            router.push('/')
          }
        })
      }
    })
  },

  setStepLevel(state, payload) {
    state.step_level = payload;
  },
  setProjectList(state, payload) {
    state.project_list = payload;
  },
  setProjectIconList(state, payload) {
    state.project_icon_list = payload;
  },
  setProjectIconImageUrls(state, payload) {
    state.project_icon_image_urls = payload;
  },
  setCurrentProject(state, payload) {
    console.log('setCurrentProject', payload)
    state.current_project = payload;
  },
  setCurrentProjectTitle(state, payload) {
    state.current_project_title = payload;
  },
  setCurrentProjectPk(state, payload) {
    state.current_project_pk = payload;
  },
  setCurrentProjectSort(state, payload) {
    state.current_project_sort = payload;

    if (!store.state.access_token) {
      console.log('store.state.access_token 없음')
      this.$store.commit('logout')
      this.$router.push('/').catch(() => {})
      return false
    }
    let body = {
      user: store.state.user_info.pk,
      project: store.state.current_project_pk,
      sort_json: payload
    }
    console.log('body', body)
    if (body.user == null) return false
    if (body.project == null) return false
    console.log('body', body)
    http
    .post('account/set-sort-item/', body, { headers: { Authorization: 'Bearer ' + store.state.access_token }})
    .then(res => {
      console.log('set-sort-item res', res)
    })
    .catch(err => {
      console.log(err)
      console.log(err.response)
      if (err.response && err.response.status === 401) { // access token 만료
        methodRecall()
        .then(msg => {
          console.log(msg)
          // method 재호출
          http
          .post('account/set-sort-item/', body, { headers: { Authorization: 'Bearer ' + store.state.access_token }})
          .then(res => {
            console.log('set-sort-item res(methodRecall)', res)
          })
        })
        .catch(err_msg => {
          console.log(err_msg)
          if (err_msg === 0) {
            console.log('BE에 access token 저장 실패')
          } else { // err_msg === 1
            console.log('refresh token 만료(access token 갱신 실패)')
            Swal.mixin({
              toast: true,
              showClass: {
                popup: 'animate__animated animate__fadeInDown'
              },
              hideClass: {
                popup: 'animate__animated animate__fadeOutUp'
              },
              position: 'top',
              showConfirmButton: false,
              showCloseButton: true,
              timer: store.getters.toastTimer,
              timerProgressBar: false,
              didOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer)
                toast.addEventListener('mouseleave', Swal.resumeTimer)
              }
            }).fire({
              icon: "warning",
              iconColor: "#ffc107",
              title: "<div style='font-size: 16px; color: #0D0E17'>다시 로그인해 주세요.<div>",
              width: store.getters.toastWidth,
              background: store.getters.toastBgColor
            })
            store.commit('logout')
            router.push('/')
          }
        })
      }
    })
  },
  setEntityLabelList(state, payload) {
    state.entity_label_list = payload;
  },

  setDataList(state, payload) {
    state.dataList = payload;
  },
  setMultiTableDataList(state, payload) {
    state.multiTableDataList = payload;
  },
  setFileList(state, payload) {
    state.file_list = payload;
  },
  setDbList(state, payload) {
    state.db_list = payload;
  },
  setStatisticsList(state, payload) {
    state.statistics_list = payload;
  },
  setOcrList(state, payload) {
    state.ocr_list = payload;
  },
  setRpaResultList(state, payload) {
    state.rpa_result_list = payload;
  },

  setRpaList(state, payload) {
    state.rpa_list = payload;
  },
  setCurrentRpa(state, payload) {
    state.current_rpa = payload;
  },
  setRpaView(state, payload) {
    state.rpa_view = payload;
  },

  setTerminologyList(state, payload) {
    state.terminologyList = payload;
  },
  setCurrentTerminologyId(state, payload) {
    state.current_terminology_id = payload;
  },
  setFilterWordList(state, payload) {
    state.filter_word_list = payload;
  },
  setAppendFileList(state, payload) {
    state.append_file_list = payload;
  },

  setAsyncTaskStatusList(state, payload) {
    state.asyncTaskStatusList = payload;
  },
  set_showAsyncTaskStatusListPanel(state, payload) {
    state.showAsyncTaskStatusListPanel = payload;
  },
  set_getDataListInterval(state, payload) {
    state.getDataListInterval = payload;
  },
  setCurrentAsyncTask(state, payload) {
    state.currentAsyncTask = payload;
  },
  setCurrentAsyncTaskLogList(state, payload) {
    state.currentAsyncTaskLogList = payload;
  },

  setMouListDataToEdit(state, payload) {
    state.mouListDataToEdit = payload;
  },

  setLastInnerDb(state, payload) {
    state.lastInnerDb = payload;
  },

  setOriginDataList(state, payload) {
    state.originDataList = payload;
  },

  setTutorialStep(state, payload) {
    state.tutorialStep = payload;
  },
  setRpaTutorialStep(state, payload) {
    state.rpaTutorialStep = payload;
  },
  setRpaTutorialHighlightRect(state, payload) {
    state.rpaTutorialHighlightRect = payload;
  },
  setDataModeTutorialStep(state, payload) {
    state.dataModeTutorialStep = payload;
  },

  setContactDialog_success(state, payload) {
    state.contactDialog_success = payload;
  },

  setEditingCellClickStep(state, payload) {
    state.editingCellClickStep = payload;
  },
  setEditTableDragAreaIdxObj(state, payload) {
    state.editTableDragAreaIdxObj = payload;
  },

  setCurrentTemplate(state, payload) {
    state.currentTemplate = payload;
  },

  setUserEmailInput_remembered(state, payload) {
    state.userEmailInput_remembered = payload;
  },

  set_file_import_data_columnSelectList1(state, payload) {
    state.file_import_data_columnSelectList1 = payload;
  },

  set_current_insight(state, payload) {
    state.current_insight = payload;
  },

  set_current_insight_folder(state, payload) {
    state.current_insight_folder = payload;
  },

  set_async_error_block_id(state, payload) {
    state.async_error_block_id = payload;
  },
};
